/**
 * Dagobah-Web-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NullableCeaInfindCeasByCta model module.
 * @module model/NullableCeaInfindCeasByCta
 * @version 2.8.0
 */
class NullableCeaInfindCeasByCta {
    /**
     * Constructs a new <code>NullableCeaInfindCeasByCta</code>.
     * @alias module:model/NullableCeaInfindCeasByCta
     * @param columnIndex {Number} 
     * @param label {String} 
     * @param uri {String} 
     */
    constructor(columnIndex, label, uri) { 
        
        NullableCeaInfindCeasByCta.initialize(this, columnIndex, label, uri);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, columnIndex, label, uri) { 
        obj['columnIndex'] = columnIndex;
        obj['label'] = label;
        obj['uri'] = uri;
    }

    /**
     * Constructs a <code>NullableCeaInfindCeasByCta</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NullableCeaInfindCeasByCta} obj Optional instance to populate.
     * @return {module:model/NullableCeaInfindCeasByCta} The populated <code>NullableCeaInfindCeasByCta</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NullableCeaInfindCeasByCta();

            if (data.hasOwnProperty('columnIndex')) {
                obj['columnIndex'] = ApiClient.convertToType(data['columnIndex'], 'Number');
            }
            if (data.hasOwnProperty('label')) {
                obj['label'] = ApiClient.convertToType(data['label'], 'String');
            }
            if (data.hasOwnProperty('uri')) {
                obj['uri'] = ApiClient.convertToType(data['uri'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} columnIndex
 */
NullableCeaInfindCeasByCta.prototype['columnIndex'] = undefined;

/**
 * @member {String} label
 */
NullableCeaInfindCeasByCta.prototype['label'] = undefined;

/**
 * @member {String} uri
 */
NullableCeaInfindCeasByCta.prototype['uri'] = undefined;






export default NullableCeaInfindCeasByCta;

